(function () {
  'use strict';

  /* @ngdoc object
   * @name productes
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes', [
      'ui.router',
      'itecAdministracio.productes.main'
    ]);
}());
